export enum ClientPickListFilter {
    ClientStatusFilter = 1,
    ClientEnabledFilter = 2,
}